// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
export const getSecondsFromDaysString = (val: string, optional = false): number | undefined => {
  // If optional then check if the input is an empty string, if so, return undefined
  if (optional && val === '') {
    return undefined;
  }

  const days = Number(val);

  return Math.floor(days * 24 * 60 * 60);
};

export const getSecondsFromDaysStringRequired = (val: string): number => {
  const days = Number(val);

  return days * 24 * 60 * 60;
};

export const getDaysFromSeconds = (val: number): number => {
  return val / (24 * 60 * 60);
};

export const getSecondsFromDDHHMM = (durationVal: string) => {
  const [str1, str2, str3] = durationVal.split(':');
  const maybeDays = Number(str1);
  const maybeHours = Number(str2);
  const maybeMins = Number(str3);

  if (!Number.isNaN(maybeDays) && Number.isNaN(maybeHours) && Number.isNaN(maybeMins)) {
    return maybeDays * 24 * 60 * 60;
  }
  if (!Number.isNaN(maybeDays) && !Number.isNaN(maybeHours) && Number.isNaN(maybeMins)) {
    return maybeDays * 24 * 60 * 60 + maybeHours * 60 * 60;
  }
  if (!Number.isNaN(maybeDays) && !Number.isNaN(maybeHours) && !Number.isNaN(maybeMins)) {
    return maybeDays * 24 * 60 * 60 + maybeHours * 60 * 60 + maybeMins * 60;
  }

  return 0;
};

export const getSecondsFromDDHH = (durationVal: string) => {
  const [str1, str2] = durationVal.split(':');
  const maybeDays = Number(str1);
  const maybeHours = Number(str2);

  if (!Number.isNaN(maybeDays) && Number.isNaN(maybeHours)) {
    return maybeDays * 24 * 60 * 60;
  }
  if (!Number.isNaN(maybeDays) && !Number.isNaN(maybeHours)) {
    return maybeDays * 24 * 60 * 60 + maybeHours * 60 * 60;
  }

  return 0;
};

export const toDDHHMM = (secs: number) => {
  const secNum = Number.parseInt(secs.toString(), 10);
  const days = Math.floor(secNum / (60 * 60 * 24));
  const hours = Math.floor(secNum / (60 * 60)) % 24;
  const minutes = Math.floor(secNum / 60) % 60;

  return [days, hours, minutes]
    .map((val) => (val < 10 ? `0${val}` : val))
    .join(':')
    .replace(/^0/, '');
};

export const toDDHH = (secs: number) => {
  const secNum = Number.parseInt(secs.toString(), 10);
  const days = Math.floor(secNum / (60 * 60 * 24));
  const hours = Math.floor(secNum / (60 * 60)) % 24;

  return [days, hours]
    .map((val) => (val < 10 ? `0${val}` : val))
    .join(':')
    .replace(/^0/, '');
};

export const createOnBlurDuration =
  (setState: (val: string) => void) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newVal = e.target.value;
    const seconds = Math.max(0, getSecondsFromDDHH(newVal));
    const time = toDDHH(seconds);
    setState(time);
  };

export const createOnBlurRequired =
  (message: string, setState: (val: string) => void) =>
  (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newVal = e.target.value;
    if (newVal === '') {
      setState(message);
    } else {
      setState('');
    }
  };
